export default __webpack_public_path__ + "static/media/shopez-loader.b12fb432.gif";